import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserSync from './UserSync';
import PlaybookSync from './PlaybookSync';
import SkillSync from './SkillSync';
import TaskCounter from './TaskCounter';

const DataSync = (props) => {
  return (
    <>
      <UserSync />
      <TaskCounter />
      <PlaybookSync />
      <SkillSync />
    </>
  );
};

DataSync.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(DataSync);
